// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"ingredients-item_itemWrapper__1vRR5","price":"ingredients-item_price__1w8x6","count":"ingredients-item_count__nFf5z","link":"ingredients-item_link__2q-Zq"};